#content-wrapper {
  display: flex;
  flex-direction: column;
}

gz-loader {
  --loader-padding-bottom: var(--spacer);
}

.loading-container {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 7);

  .loading-header {
    padding: var(--spacer) 0;
    gap: calc(var(--spacer) * 3);

    gz-loader {
      height: fit-content;
    }
  }
}

.loading-header,
.header {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 9);
  width: 100%;

  gz-widget-header-item {
    flex: 1;
  }

  .vertical-bar {
    background-color: var(--chart-101-pressed-dividers);
    width: 1px;
    height: 100%;
    margin: calc(var(--spacer) * 1.5);
  }
}

.header {
  padding: var(--spacer) 0;
}

.section {
  display: flex;
  flex-direction: column;
  padding-top: calc(var(--spacer) * 3);

  .section-title {
    display: inline;
    line-height: calc(var(--spacer) * 4);
    cursor: default;
  }

  .section-title {
    text-transform: uppercase;
    font-weight: 600;
    color: var(--chart-300-icon-buttons);
  }
}

.changed-info-box {
  position: relative;

  > * {
    position: absolute;
    background-color: var(--white-layout-302-level-1-elevation);
    z-index: 1;
  }
}

.mac-os-infobox {
  > * {
    padding-bottom: 10% !important;
    --info-box-width: 100%;
    --info-box-message-width: calc(100% - var(--spacer) * 7);
  }
}
